import { render, staticRenderFns } from "./RowActions.vue?vue&type=template&id=20e453ec&"
import script from "./RowActions.vue?vue&type=script&lang=js&"
export * from "./RowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports